import styled from "styled-components"
import { Row as row } from "antd"

const Row = styled(row)`
  display: flex;
`

/** @component */
export default Row
